export default __webpack_public_path__ + "static/media/lockrScan-preview.f78ed4b4.svg";